export type Currency = 'eur' | 'usd';

type PlanPrices = {
  eur: { monthly: string; yearly: string };
  usd: { monthly: string; yearly: string };
};

export const currencySymbol: Record<Currency, string> = {
  eur: '€',
  usd: '$',
};

export const planPrices: Record<string, PlanPrices> = {
  'MMM Starter': {
    eur: { monthly: '290', yearly: '3,480' },
    usd: { monthly: '490', yearly: '5,880' },
  },
  'Digital Growth': {
    eur: { monthly: '890', yearly: '10,680' },
    usd: { monthly: '1,490', yearly: '17,880' },
  },
  'Omnichannel Growth': {
    eur: { monthly: '1,290', yearly: '15,480' },
    usd: { monthly: '1,990', yearly: '23,880' },
  },
  'Enterprise Scale': {
    eur: { monthly: '1,690', yearly: '20,280' },
    usd: { monthly: '2,490', yearly: '29,880' },
  },
};
